export default class AjaxFormSubmitter {
  constructor(dataSource) {
    this.dataSource = dataSource;
  }

  submit(callback, options) {
    const form = options.form,
      formInfo = this.getFormInfo(form);

    let formData = this.getFormData(form);
    let dataProvider = callback => {
      callback(formData);
    };

    if (options.onData) {
      dataProvider = options.onData(formData, form);
    }

    if (dataProvider && dataProvider.constructor === Function) {
      dataProvider(data => {
        formInfo.data = data;
        this.dataSource.request(callback, formInfo);
      });
    }
  }

  getFormInfo(form) {
    const action = form.getAttribute("action"),
      enctype = form.getAttribute("enctype"),
      method = form.getAttribute("method"),
      formInfo = {
        url: action,
        method: method,
        enctype: enctype
      };
    return formInfo;
  }

  getFormData(form) {
    const data = {};
    this.onEachField(field => {
      data[field.name] = field.value;
    }, form);
    return data;
  }

  onEachField(callback, form) {
    const fieldList = form.querySelectorAll("[name]");
    fieldList.forEach(field => {
      callback(field);
    });
  }
}
